const images = [
  {
    src: "https://static.billboard.com/files/media/Taylor-Swift-1989-album-covers-billboard-1000x1000-compressed.jpg",
    title: "Taylor Swift / 1989"
  },
  {
    src: "https://static.billboard.com/files/media/cardi-b-invasion-of-privacy-album-art-2018-billboard-embed-compressed.jpg",
    title: "Cardi B / Invasion of Privacy"
  },
  {
    src: "https://static.billboard.com/files/media/Fleetwood-Mac-Rumours-album-covers-billboard-1000x1000-compressed.jpg",
    title: "Fleetwood Mac / Rumours"
  },
  {
    src: "https://images-na.ssl-images-amazon.com/images/I/71Ln3JLWyOL._SL1500_.jpg",
    title: "Adele / 21"
  },
  {
    src: "https://static.billboard.com/files/media/No-Doubt-Tragic-Kingdom-album-covers-billboard-1000x1000-compressed.jpg",
    title: "No Doubt / Tragic Kingdom"
  },
  {
    src: "https://static.billboard.com/files/media/To-pimp-a-butterfly-kendrick-lamar-no1-albums-billboard-1000x1000-compressed.jpg",
    title: "Kendrik Lamar / To Pimp a Butterfly"
  },
  {
    src: "https://static.billboard.com/files/media/Pink-Floyd-Dark-Side-of-the-Moon-album-covers-billboard-1000x1000-compressed.jpg",
    title: "Pink Floyd / Dark Side of the Moon"
  },
  {
    src: "https://static.billboard.com/files/media/The-Beatles-Abbey-Road-album-covers-billboard-1000x1000-compressed.jpg",
    title: "The Beatles / Abbey Road"
  },
  {
    src: "https://www.udiscovermusic.com/wp-content/uploads/2015/10/Kanye-West-Yeezus.jpg",
    title: "Kanye West / Yeezus"
  },
  {
    src: "https://www.udiscovermusic.com/wp-content/uploads/2015/10/Janelle-Mona%CC%81e-Dirty-Computer-.jpg",
    title: "Janelle Monáe / Dirty Computer"
  },
  {
    src: "https://images-na.ssl-images-amazon.com/images/I/91HWgZeXd%2BL._SL1500_.jpg",
    title: "Santana / Supernatural"
  },
  {
    src: "https://www.udiscovermusic.com/wp-content/uploads/2017/08/Prince-Purple-Rain.jpg",
    title: "Prince / Purple Rain"
  },
  {
    src: "https://www.udiscovermusic.com/wp-content/uploads/2017/08/Green-Day-Dookie.jpg",
    title: "Green Day / Dookie"
  },
  {
    src: "http://res.cloudinary.com/ybmedia/image/upload/c_crop,h_1000,w_1000,x_0,y_0/c_scale,f_auto,q_auto,w_700/v1/m/b/7/b719a21e6157baff2c01e4cc0cdce01af1dfc03d/23Tribe.png",
    title: "A Tribe Called Quest / The Low-End Theory"
  },
  {
    src: "http://res.cloudinary.com/ybmedia/image/upload/c_crop,h_1000,w_1000,x_0,y_0/c_scale,f_auto,q_auto,w_700/v1/m/5/9/59986916193cde5e6a8ae0dc7acec5731c4dabc4/34OutKast.jpg",
    title: "OutKast / Stankonia"
  },
  {
    src: "http://res.cloudinary.com/ybmedia/image/upload/c_crop,h_1200,w_1200,x_0,y_0/c_scale,f_auto,q_auto,w_700/v1/m/d/a/da33cddda1d779c6bceeac8d69ee7f6df80f9315/36Madvill.jpg",
    title: "Madvillian / Madvillainy"
  },
  {
    src: "https://images-na.ssl-images-amazon.com/images/I/91j5pX9RdHL._SL1500_.jpg",
    title: "Lauryn Hill / The Miseducation of Lauryn Hill"
  },
  {
    src: "https://images-na.ssl-images-amazon.com/images/I/61-Np%2BdUtQL._SL1400_.jpg",
    title: "Drake / Nothing Was The Same"
  },
  {
    src: "https://www.nme.com/wp-content/uploads/2016/09/2013JayZ_MagnaCarta600G030713-1.jpg",
    title: "Jay-Z / Magna Carta Holy Grail"
  },
  {
    src: "https://images-na.ssl-images-amazon.com/images/I/61yver5nJSL._SL1200_.jpg",
    title: "Childish Gambino / Because the Internet"
  },
  {
    src: "https://upload.wikimedia.org/wikipedia/en/8/88/Love_Yourself_Tear_Cover.jpeg",
    title: "BTS / Love Yourself: Tear"
  },
  {
    src: "https://upload.wikimedia.org/wikipedia/en/8/81/Arcade_Fire_-_The_Suburbs.jpg",
    title: "Arcade Fire / The Suburbs"
  },
  {
    src: "https://upload.wikimedia.org/wikipedia/en/5/53/Beyonce_-_Lemonade_%28Official_Album_Cover%29.png",
    title: "Beyoncé / Lemonade"
  },
  {
    src: "https://images-na.ssl-images-amazon.com/images/I/61S8tQvJ3yL._SL1200_.jpg",
    title: "Janet Jackson / Control"
  },
  {
    src: "https://images-na.ssl-images-amazon.com/images/I/815m4ZL21cL._SL1500_.jpg",
    title: "Alicia Keys / The Diary of Alicia Keys"
  }
];

export default images;
